<template>
  <v-ons-page>

    <v-ons-splitter>
      <v-ons-splitter-side swipeable collapse width="250px" side="right"
        :animation="$ons.platform.isAndroid() ? 'overlay' : 'reveal'"
        :open.sync="menuIsOpen">
        <filters-menu
          :type="type"
          @refreshList="refreshList">
        </filters-menu>
      </v-ons-splitter-side>

      <v-ons-splitter-content>
        <filters-list
          :type="type"
          :products="products"
          @toggleMenu="menuIsOpen = !menuIsOpen"
          @push-page="push">
        </filters-list>
      </v-ons-splitter-content>
    </v-ons-splitter>

  </v-ons-page>
</template>

<script>
import FiltersMenu from './FiltersMenu'
import FiltersList from './FiltersList'
import { appData } from '../data.js'

export default {
  name: 'filters',
  props: {
    type: Object,
    pushPage: Function
  },
  components: {
    FiltersMenu,
    FiltersList
  },
  data () {
    return {
      products: appData.state.products.filter(p => p.type === this.type.id),
      menuIsOpen: false
    }
  },
  methods: {
    push(page) {
      this.$emit('push-page', page);
    },
    refreshList(filteredProducts) {
      this.products = filteredProducts;
    }
  },
    created() {
            let productsOfType = appData.state.products.filter(p => p.type === this.type.id);
            let completedNames = [];
            let completedAreas = [];

            productsOfType.forEach(p => {
                let nameCallback = (result) => {
                    p.NameSvgString = result;
                    completedNames.push(p);
                    productPushed();
                };

                let areaCallback = (result) => {
                    p.ProductAreaSvgString = result;
                    completedAreas.push(p);
                    productPushed();
                };

                let productPushed = () => {
                    if (completedAreas.length === productsOfType.length && completedNames.length === productsOfType.length) {
                        this.products = productsOfType;
                    }
                };

                nameCallback(p.NameSvg);
                areaCallback(p.DetailsSvg);
            });
        },
}
</script>



// WEBPACK FOOTER //
// src/components/Filters.vue